import axiosInstance from './axiosInstance';

const completedTaskById = (taskId) =>
  axiosInstance.patch(`/internal/admin/tasks/${taskId}`);

export default completedTaskById;
